/**
 * Підпис виробничого замовлення: «№777 · ВЗ #46» (як у планері + внутрішній id).
 * Якщо номера клієнта немає — лише «ВЗ #46».
 */

export function formatProductionOrderRef({
  orderId = null,
  customerOrderNumber = null,
  productionOrderId = null,
} = {}) {
  const oid = orderId ?? productionOrderId;
  const co = customerOrderNumber != null && String(customerOrderNumber).trim() !== ''
    ? String(customerOrderNumber).trim()
    : null;
  if (oid == null && !co) return '—';
  if (co && oid != null) return `№${co} · ВЗ #${oid}`;
  if (co) return `№${co}`;
  return `ВЗ #${oid}`;
}

/** Заголовок з виробом / ТПА: «№777 · ВЗ #46 · Корпус · ТПА-19» */
export function formatProductionOrderTitle({
  orderId = null,
  customerOrderNumber = null,
  productionOrderId = null,
  productName = null,
  machineIdentifier = null,
} = {}) {
  const parts = [
    formatProductionOrderRef({ orderId, customerOrderNumber, productionOrderId }),
  ];
  const name = (productName || '').trim();
  if (name) parts.push(name);
  const mid = (machineIdentifier || '').trim();
  if (mid) parts.push(mid);
  return parts.filter((p) => p && p !== '—').join(' · ');
}

/** З об'єкта API (різні імена полів). */
export function orderRefFromRow(row) {
  if (!row || typeof row !== 'object') return '—';
  if (row.order_ref_display) return row.order_ref_display;
  if (row.order_title_display) return row.order_title_display;
  const oid =
    row.production_order_id ??
    row.production_order ??
    row.order_id ??
    row.order ??
    (typeof row.order_number === 'number' ? row.order_number : null);
  const co =
    row.customer_order_number ??
    row.order_customer_order_number ??
    row.production_order_number ??
    null;
  // production_order_number іноді вже є номером клієнта (BlockedStock) — якщо виглядає як id і = oid, не дублюємо як №
  let customerOrderNumber = co;
  if (
    customerOrderNumber != null &&
    oid != null &&
    String(customerOrderNumber) === String(oid)
  ) {
    customerOrderNumber = null;
  }
  return formatProductionOrderRef({
    orderId: oid,
    customerOrderNumber,
  });
}
